// Determines our (i.e. the Web Builder) consumer

enum ClientPlatformEnum {
  iOS = 0,
  Android = 1,
  Safari = 2,
  Web = 3,
}

const getClientPlatform = (): ClientPlatformEnum => {
  if (global.webkit && global.webkit.messageHandlers && global.webkit.messageHandlers.saveAvatar) {
    return ClientPlatformEnum.iOS;
  } else if (
    navigator.userAgent.indexOf('Safari') > -1 &&
    navigator.vendor.match(/apple/i) // Chrome uses Safari in its User Agent
  ) {
    // We make the distinction between Safari and "Web" because Safari does not
    // support WebP.
    return ClientPlatformEnum.Safari;
  } else if (global.Android) {
    return ClientPlatformEnum.Android;
  } else {
    return ClientPlatformEnum.Web;
  }
};

const clientPlatform: ClientPlatformEnum = getClientPlatform();
console.log('Client platform:', clientPlatform);

export { clientPlatform, ClientPlatformEnum };
